import { defineStore } from 'pinia';
import axios from 'axios';
import Cookies from 'js-cookie';
import { stringify } from 'query-string';

const API_URL = {
    filters: '/api/v2/land/auctions/filters/',
    // filters: 'http://192.168.1.3:8081/filters.json',
    // filters: 'img/filters.json',
    items: '/api/v2/land/auctions/list/',
    // items: 'http://192.168.1.3:8081/items.json',
    // items: 'img/items.json',
    filtersAuctions: '/api/v2/land/auctions/filters/?type=auctions',
    // filtersAuctions: 'img/filters.json/?type=auctions',
    itemsAuctions: '/api/v2/land/auctions/list/?type=auctions',
    // itemsAuctions: 'img/items.json/?type=auctions',
    filtersArchive: '/api/v2/land/auctions/filters/?type=archive',
    itemsArchive: '/api/v2/land/auctions/list/',
    itemsPdf: '/api/v2/land/auctions/list/download/pdf/',
    itemsListPdf: '/api/v2/land/auctions/list/download/pdf/list/',
    // map: 'img/map.json',
    map: '/api/v2/land/auctions/map/',
    // item: 'img/map-object.json?id=',
    item: '/api/v2/land/auctions/item/',
    // itemsPdf: 'http://localhost:8081/items-pdf.json'
    // items: 'img/favouritesMock.json',
};

// eslint-disable-next-line import/prefer-default-export
export const useAuctionsBaseStore = defineStore('auctionsBase', {
    state: () => ({
        filters: {},
        items: [],
        mapItems: [],
        calendar: [],
        similar: [],
        activeItem: {},
        activeListItem: [],
        nav: {},
        mapNav: {},
        localFilters: {},
        requestCoreParams: {},
        pagination: {
            page: 1,
            'page-size': 8,
        },
        sort: {
            price: null,
            date: null,
        },
        fetch: {
            isFetching: false,
            isFetched: false,
        },
        loadedLocationByUrl: false,
        meta: {},
        URLParams: null,
    }),
    getters: {
        landPageCnt: (state) => {
            if (!Cookies.get('land-page-cnt')) {
                Cookies.set('land-page-cnt', state.pagination['page-size']);
            }
            return state.pagination['page-size'];
        },
        currentPage: (state) => state.nav.NavPageNomer || state.pagination.page,
        pageCount: (state) => state.nav.NavPageCount || state.pagination.page,
        navRecordCount: (state) =>
            state.nav.NavRecordCount || state.pagination['page-size'],
        mapNavRecordCount: (state) => state.mapNav.NavRecordCount,
        navPageSize: (state) =>
            state.nav.NavPageSize || state.pagination['page-size'],
    },

    actions: {
        /**
         * Получение и сохранение фильтров
         * @returns {Promise<unknown>}
         */
        async fetchFilters(params = '') {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            return axios
                .get(API_URL.filters + params)
                .then((response) => {
                    if (response.data.success) {
                        this.setDataFilters(response.data.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },
        /**
         * Archive
         * @returns {Promise<unknown>}
         */
        async fetchFiltersArchive() {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            return axios
                .get(API_URL.filtersArchive)
                .then((response) => {
                    if (response.data.success) {
                        this.setDataFilters(response.data.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },
        /**
         * Auctions
         * @returns {Promise<unknown>}
         */
        async fetchFiltersAuctions() {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            return axios
                .get(API_URL.filtersAuctions)
                .then((response) => {
                    if (response.data.success) {
                        this.setDataFilters(response.data.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },
        setDataFilters(data) {
            if (!Object.keys(this.filters).length) {
                this.filters = data;
            } else {
                Object.keys(this.filters).forEach((key) => {
                    if (key !== 'type' && data[key]) {
                        this.filters[key] = data[key];
                    }
                });
            }
            this.fetch.isFetched = true;
            this.pagination['page-size'] = this.landPageCnt;
            this.similar = [];
        },

        /**
         * Получение списка объектов, с учетом фильтров
         * @returns {Promise<unknown>}
         */
        async fetchItems(noPagination = false) {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            const activeSorts = [];
            if (this.sort.price) {
                activeSorts.push(`price_${this.sort.price}`);
            }
            if (this.sort.date) {
                activeSorts.push(`date_${this.sort.date}`);
            }
            const params = noPagination
                ? {
                      ...this.requestCoreParams,
                      sort: activeSorts,
                      ...this.localFilters,
                  }
                : {
                      ...this.requestCoreParams,
                      sort: activeSorts,
                      ...this.pagination,
                      ...this.localFilters,
                  };
            if (params.location === 'none') {
                params.location = null;
            }
            const URIParams = `?${stringify(params, {
                arrayFormat: 'comma',
                skipNull: true,
                skipEmptyString: true,
            })}`;

            return axios
                .get(API_URL.items + URIParams)
                .then((response) => {
                    if (response.data.success) {
                        this.items = response.data.data;
                        this.nav = response.data.nav;
                        this.meta = response.data.meta;
                        if (response.data.calendar) {
                            this.calendar = response.data.calendar;
                        }
                        if (response.data.similar) {
                            this.similar = response.data.similar;
                        } else {
                            this.similar = [];
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.fetch.isFetched = false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },

        /**
         * Получение списка объектов (объявленных), с учетом фильтров
         * @returns {Promise<unknown>}
         */
        async fetchItemsAuctions(noPagination = false) {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            const activeSorts = [];
            if (this.sort.price) {
                activeSorts.push(`price_${this.sort.price}`);
            }
            if (this.sort.date) {
                activeSorts.push(`date_${this.sort.date}`);
            }
            const params = noPagination
                ? {
                      ...this.requestCoreParams,
                      sort: activeSorts,
                      ...this.localFilters,
                  }
                : {
                      ...this.requestCoreParams,
                      sort: activeSorts,
                      ...this.pagination,
                      ...this.localFilters,
                  };
            const URIParams = `&${stringify(params, {
                arrayFormat: 'comma',
                skipNull: true,
                skipEmptyString: true,
            })}`;
            return axios
                .get(API_URL.itemsAuctions + URIParams)
                .then((response) => {
                    if (response.data.success) {
                        this.items = response.data.data;
                        this.nav = response.data.nav;
                        if (response.data.calendar) {
                            this.calendar = response.data.calendar;
                        }
                        if (response.data.similar) {
                            this.similar = response.data.similar;
                        } else {
                            this.similar = [];
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.fetch.isFetched = false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },

        /**
         * Получение списка точек, с учетом фильтров
         * @returns {Promise<unknown>}
         */
        async fetchMap() {
            this.activeItem = {};
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            const params = {
                ...this.requestCoreParams,
                ...this.pagination,
                ...this.localFilters,
            };
            const URIParams = `?${stringify(params, {
                arrayFormat: 'comma',
                skipNull: true,
                skipEmptyString: true,
            })}`;
            return axios
                .get(API_URL.map + URIParams)
                .then((response) => {
                    if (response.data.success) {
                        this.mapItems = response.data.data;
                        this.mapNav = response.data.nav;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.fetch.isFetched = false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },

        /**
         * Получение списка точек, с учетом фильтров
         * @returns {Promise<unknown>}
         */
        async fetchItem(id) {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            return axios
                .get(`${API_URL.item + id}/`)
                .then((response) => {
                    if (response.data.success) {
                        this.activeItem = response.data.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.fetch.isFetched = false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },

        async fetchListItem(id) {
            this.activeListItem = [];
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            for (let i = 0; i < id.length; i++) {
                axios
                    .get(`${API_URL.item + id[i]}/`)
                    .then((response) => {
                        if (response.data.success) {
                            this.activeListItem.push(response.data.data);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.fetch.isFetched = false;
                    })
                    .finally(() => {
                        if (i === id.length - 1) {
                            this.fetch.isFetching = false;
                        }
                    });
            }
            return this.activeListItem;
        },

        /**
         * Получение списка объектов Archive, с учетом фильтров
         * @returns {Promise<unknown>}
         */
        async fetchItemsArchive() {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            const activeSorts = [];
            if (this.sort.price) {
                activeSorts.push(`price_${this.sort.price}`);
            }
            if (this.sort.date) {
                activeSorts.push(`date_${this.sort.date}`);
            }
            const params = {
                ...this.requestCoreParams,
                sort: activeSorts,
                ...this.pagination,
                ...this.localFilters,
            };
            const URIParams = `?${stringify(params, {
                arrayFormat: 'comma',
                skipNull: true,
                skipEmptyString: true,
            })}`;
            return axios
                .get(API_URL.itemsArchive + URIParams)
                .then((response) => {
                    if (response.data.success) {
                        this.items = response.data.data;
                        this.nav = response.data.nav;
                        if (response.data.calendar) {
                            this.calendar = response.data.calendar;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.fetch.isFetched = false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },

        async downloadPdf(type) {
            this.fetch.isFetching = true;
            const params = {
                ...this.localFilters,
            };

            const URIParams = `?${stringify(params, {
                arrayFormat: 'comma',
                skipNull: true,
                skipEmptyString: true,
            })}`;
            return axios
                .get(
                    (type === 'list'
                        ? API_URL.itemsListPdf
                        : API_URL.itemsPdf) + URIParams
                )
                .then((response) => {
                    if (response.data.success) {
                        return response.data.src;
                    }
                    return false;
                })
                .catch((error) => {
                    console.log(error);
                    return false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },

        setLocalFilter(filters, pagination = null, filtersData = null) {
            this.localFilters = filters;
            if (
                !this.loadedLocationByUrl &&
                filtersData &&
                typeof filtersData.location.url === 'object'
            ) {
                this.loadedLocationByUrl = true;
                const arUrl = window.location.pathname.split('/');
                if (
                    arUrl[2] &&
                    arUrl[2] !== 'calendar' &&
                    arUrl[2] !== 'archive'
                ) {
                    // ищем по городам
                    const findLocation = Object.keys(
                        filtersData.location.url
                    ).find((key) => filtersData.location.url[key] === arUrl[2]);
                    if (findLocation) {
                        this.localFilters.location = findLocation;
                    } else {
                        // ищем по фо
                        const findLocation = Object.keys(
                            filtersData.fo.values
                        ).find((key) => key === arUrl[2]);
                        if (findLocation) {
                            let keyFo = filtersData.fo.values[findLocation];
                            let region = Object.keys(
                                filtersData.location.structure[keyFo]
                            );
                            this.localFilters.location = region;
                            this.localFilters.fo = findLocation;
                        }
                        // this.localFilters.location = 'none';
                    }
                }
            }
            if (!pagination || !Object.keys(pagination).length) {
                this.pagination.page = 1;
            } else {
                this.pagination = { ...this.pagination, ...pagination };
                if (this.pagination['page-size'] !== pagination['page-size']) {
                    // this.changePageSize(pagination);
                }
            }
        },

        changePage(n, noAgency = false) {
            this.pagination.page = n;
            if (noAgency) return this.fetchItemsAuctions(false, noAgency);
            return this.fetchItems();
        },

        changePageSize(n, noAgency = false) {
            this.pagination['page-size'] = n;
            Cookies.set('land-page-cnt', n);
            if (noAgency) return this.fetchItemsAuctions(false, noAgency);
            return this.fetchItems();
        },

        /*
         * Необходимо выполнять сортировку только по одному полю.
         * Обнуляет сортировку всех полей, кроме переданного
         */
        sortToNull(name) {
            const sortKeys = Object.keys(this.sort);
            const filterKeys = sortKeys.filter((item) => item !== name);
            filterKeys.forEach((item) => {
                this.sort[item] = null;
            });
        },

        updateSort({ name, value }, fetchOptions = {}, noAgency = false) {
            this.sortToNull(name);
            this.sort[name] = value;
            this.pagination.page = 1;
            if (noAgency)
                return this.fetchItemsAuctions(...Object.values(fetchOptions));
            return this.fetchItems(...Object.values(fetchOptions));
        },

        /**
         * Задание обязательных параметров для запросов
         * @param params
         */
        setCoreParams(params) {
            this.requestCoreParams = params;
        },

        /**
         * Для оптимизации SEO монтируем список объектов из props, приходящих с сервера
         * в land/auctions/index.php
         */
        addItems(items) {
            if (this.items.length === 0) {
                this.items = items;
            } else {
                return false;
            }
        },

        addNav(navItem) {
            this.nav = navItem;
        },
        setURLParams(params) {
            this.URLParams = params;
        },
    },
});
